<template>
  <div class="vx-row">
    <div class="vx-col sm:w-1/3 w-full flex items-center">
      <span>Driver
        <small class="text-xs" style="color: red">* (Don't choose if you want to see all)</small></span>
    </div>
    <div class="vx-col sm:w-2/3 w-full">
      <multiselect v-model="selected" :options="options" placeholder="Type to search" track-by="PersonalID"
        :allow-empty="true" :multiple="true" :custom-label="customLabel" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    warehouse_id: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/drivers",
      options: [],
      selected: null,
    };
  },
  methods: {
    customLabel(option) {
      return `${option.personal.name}`;
    },
    onSearch(query) {
      let params = {
        company_id: this.$store.state.user.currentUser.company_id,
        search: query,
      };
      this.getDataByTerritory(params);
    },
    reset() {
      this.selected = null;
      this.options = [];
    },
    getDataByTerritory(params) {
      console.log(params)
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: params,
        })
        .then((resp) => {
          if (resp.code == 200) {
            if (resp.data.records != null) {
              var options = [];
              resp.data.records.forEach(function (item) {
                options.push(item);
              }, options);
              this.options = options;
            } else {
              this.options = [];
            }
            this.$vs.loading.close();
          } else {
            this.$vs.loading.close();
            console.log(resp.data);
          }
        });
    },
  },
  watch: {
    selected(v) {
      if (!v) {
        this.$emit("data", []);
        return;
      }

      const result = v.map(item => ({
        id: item.id,
        name: item.personal.name
      }));

      this.$emit("data", result);
    }
  },
  mounted() { },
};
</script>
